import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Text,
} from '@chakra-ui/react';
// eslint-disable-next-line no-restricted-imports
import { Field, Form, Formik } from 'formik';
import { FC, useState } from 'react';
import { Button } from 'src/components/atoms/Button';
import { ErrorNotifBox } from 'src/components/atoms/ErrorNotifBox';
import { useFontErrorColor } from 'src/hooks/colors/useErrorColor';
import { FormikField } from './types';
import { validatePassword } from './validators';

type NewPasswordProps = {
  email?: string;
  onSubmit: (newPassword: string) => void;
};

/**
 * This component shows is required when a user needs to set a new password
 * (usually at first sign in with a new account).
 */
export const NewPassword: FC<NewPasswordProps> = ({ email, onSubmit }) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const errorMessageColor = useFontErrorColor();

  return (
    <Formik
      initialValues={{
        newPassword: '',
      }}
      onSubmit={async (values) => {
        try {
          setErrorMessage(null);
          await onSubmit(values.newPassword);
        } catch (error) {
          if (error instanceof Error) {
            setErrorMessage(error.message);
          }
        }
      }}>
      {(props) => (
        <Form>
          {email && (
            <Box pb={4}>
              <Text>Please set a new password for {email}</Text>
            </Box>
          )}
          <Field name="newPassword" validate={validatePassword}>
            {({ field, form }: FormikField) => (
              <FormControl
                my={4}
                isInvalid={form.errors.newPassword && form.touched.newPassword}>
                <FormLabel
                  htmlFor="newPassword"
                  fontFamily="marketingPage"
                  fontSize="16px"
                  fontWeight={500}
                  color="content.title"
                  mb={3}>
                  New Password
                </FormLabel>
                <Input
                  {...field}
                  type="password"
                  id="newPassword"
                  _placeholder={{ color: 'content.muted' }}
                  bg="surface.panel"
                  border="1px solid"
                  borderColor="surface.border"
                  borderRadius="md"
                  _focus={{
                    borderColor: 'icon.green',
                    boxShadow: '0 0 0 1px var(--chakra-colors-icon-green)',
                  }}
                />
                <FormErrorMessage color={errorMessageColor}>
                  {form.errors.newPassword}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
          {errorMessage && <ErrorNotifBox title={errorMessage} />}
          <Flex direction="row" justifyContent="flex-end">
            <Button
              buttonName="change-password"
              mt={4}
              isLoading={props.isSubmitting}
              type="submit">
              Change Password
            </Button>
          </Flex>
        </Form>
      )}
    </Formik>
  );
};
